var _g, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_364_7553)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 70C80 75.5228 75.5229 80 70 80L26.1803 80C22.3926 80 18.93 77.86 17.2361 74.4721L2.23607 44.4721C0.828433 41.6569 0.828431 38.3431 2.23607 35.5279L17.2361 5.52787C18.93 2.14003 22.3926 0 26.1803 0L70 0C75.5228 0 80 4.47715 80 10L80 70Z",
    fill: "url(#paint0_linear_364_7553)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 70C80 75.5228 75.5229 80 70 80L26.1803 80C22.3926 80 18.93 77.86 17.2361 74.4721L2.23607 44.4721C0.828433 41.6569 0.828431 38.3431 2.23607 35.5279L17.2361 5.52787C18.93 2.14003 22.3926 0 26.1803 0L70 0C75.5228 0 80 4.47715 80 10L80 70Z",
    fill: "#B7BCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 70C80 75.5228 75.5229 80 70 80L26.1803 80C22.3926 80 18.93 77.86 17.2361 74.4721L2.23607 44.4721C0.828433 41.6569 0.828431 38.3431 2.23607 35.5279L17.2361 5.52787C18.93 2.14003 22.3926 0 26.1803 0L70 0C75.5228 0 80 4.47715 80 10L80 70Z",
    fill: "#6B7787"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.272,
    y: 52.7279,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-135 54.272 52.7279)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6448,
    y: 49.8995,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-45 31.6448 49.8995)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_364_7553",
    x: 1.18042,
    y: 0,
    width: 78.8196,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_364_7553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_364_7553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_364_7553",
    x1: 40,
    y1: -0.00000259452,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CBD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.367f358c9d3285f424b8f92af1a3ce7d.svg";
export { ForwardRef as ReactComponent };